import HandleVideoEmbeds from '@app/scripts/HandleVideoEmbeds';

class EmbedCover {
	constructor(
		blockSelector = '[data-embed-cover="block"]', // block first ancestor selector
		holderSelector = '[data-embed-cover="holder"]', // iframe and cover holder selector
		coverSelector = '[data-embed-cover="cover"]' // cover selector
	) {

		this.blockSelector = blockSelector;
		this.holderSelector = holderSelector;
		this.coverSelector = coverSelector;
		this.embedList = [];
		this.embedCurrentTime = [];

		this._clickPlay();
	}

	_clickPlay() {
		window.addEventListener('click', event => {
			if (
				event.target &&
				event.target.closest(this.coverSelector)
			) {
				event.preventDefault();
				const holder = event.target.closest(this.holderSelector);


				if (!holder) return;

				const iframe = holder.querySelector('iframe');

				iframe.embedPlayer = new HandleVideoEmbeds({
					containerSel: '[data-embed-cover="block"]',
					coverSelector: '[data-embed-cover="cover"]',
					iframeElement: iframe,
					onReady: () => {
						iframe.embedPlayer.play();
					},
				});
			}
		});
	}
}
export const embedCover = new EmbedCover();
